/* Five-step offer flow. Answers stay in the current document. */
(() => {
  'use strict';
  const titles = ['Cu ce te putem ajuta?', 'Ce vrei să obții?', 'Ai deja un site?', 'Buget', 'Datele tale'];
  const defaults = {'creare-site-prezentare':'Site de prezentare','creare-site-web':'Site de prezentare','creare-site-web-suceava':'Site de prezentare','web-design-suceava':'Site de prezentare','creare-magazin-online':'Magazin online','creare-logo':'Logo','google-ads':'Google Ads','promovare-facebook-ads':'Facebook & Instagram Ads','optimizare-seo':'SEO'};
  function validWebsite(value) {
    const raw = value.trim();
    if (!raw || /\s/.test(raw)) return false;
    try {
      const url = new URL(/^https?:\/\//i.test(raw) ? raw : 'https://' + raw);
      return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password && url.hostname.includes('.') && url.hostname.split('.').every(part => /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(part));
    } catch { return false; }
  }
  for (const form of document.querySelectorAll('[data-guided-offer]')) {
    if (form.bossnetGuided) continue;
    const steps = [...form.querySelectorAll('[data-guided-step]')];
    const title = form.querySelector('[data-guided-title]');
    const counter = form.querySelector('[data-guided-counter]');
    const progress = form.querySelector('[role=progressbar]');
    const status = form.querySelector('[data-bridge-status]');
    const recovery = form.querySelector('[data-guided-recovery]');
    const dialog = form.closest('dialog');
    let step = 1, timer, animation;
    const busy = () => form.getAttribute('aria-busy') === 'true';
    const visible = () => !form.hidden && (!dialog || dialog.open);
    const selected = name => [...form.querySelectorAll(`[name="${name}"]:checked`)].map(input => input.value);
    function clearError() {
      status.hidden = true;
      recovery.hidden = true;
    }
    function show(next, focus = true, track = false) {
      clearTimeout(timer);
      if (busy()) return;
      step = Math.max(1, Math.min(5, next));
      form.dataset.guidedStep = String(step);
      steps.forEach((panel, index) => { panel.hidden = index !== step - 1; });
      title.textContent = titles[step - 1];
      counter.textContent = `Pasul ${step} din 5`;
      progress.setAttribute('aria-valuenow', String(step));
      progress.setAttribute('aria-label', counter.textContent);
      progress.firstElementChild.style.width = `${step * 20}%`;
      clearError();
      if (track && visible()) form.dispatchEvent(new CustomEvent('bossnet:offer-step', {detail:{step}}));
      if (focus) {
        if (dialog) dialog.scrollTop = 0;
        else form.scrollIntoView({block:'start', behavior:'instant'});
        title.focus({preventScroll:true});
        animation?.cancel();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) animation = steps[step-1].animate([{opacity:0,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}], {duration:160,easing:'ease-out'});
      }
    }
    function fail(message, input) {
      form.dispatchEvent(new CustomEvent('bossnet:form-error', {detail:{category:'validation'}}));
      status.textContent = message;
      status.hidden = false;
      status.setAttribute('role','alert');
      if (input) {
        input.setAttribute('aria-invalid','true');
        input.focus();
      } else status.focus();
      return false;
    }
    function validate(index) {
      if (index === 1 && !selected('services').length) return fail('Selectează cel puțin o opțiune.', form.querySelector('[name=services]'));
      if (index === 2 && !selected('goals').length) return fail('Selectează cel puțin o opțiune.', form.querySelector('[name=goals]'));
      if (index === 3) {
        const choice = selected('has_site')[0];
        if (!choice) return fail('Alege Da sau Nu.', form.querySelector('[name=has_site]'));
        if (choice === 'Da' && !validWebsite(form.elements.site_url.value)) return fail('Introdu o adresă validă, de exemplu www.exemplu.ro.',form.elements.site_url);
      }
      if (index === 4 && !selected('budget').length) return fail('Alege un interval de buget.', form.querySelector('[name=budget]'));
      if (index === 5) {
        const name = form.elements.name, phone = form.elements.phone;
        if (name.value.trim().length < 2) return fail('Introdu un nume valid.',name);
        const digits = phone.value.replace(/\D/g,'');
        if (!/^[+0-9 ().-]+$/.test(phone.value.trim()) || digits.length < 7 || digits.length > 15) return fail('Introdu un număr de telefon valid.',phone);
        const invalid = [...steps[4].querySelectorAll('input')].find(input => !input.checkValidity());
        if (invalid) return fail(invalid.name === 'email' ? 'Verifică adresa de email.' : 'Verifică acest câmp.', invalid);
      }
      return true;
    }
    function advance() {
      if (busy() || !validate(step)) return;
      if (step < 5) show(step + 1, true, true);
    }
    form.querySelectorAll('[data-guided-next]').forEach(button => button.addEventListener('click', advance));
    form.querySelectorAll('[data-guided-back]').forEach(button => button.addEventListener('click', () => { if (!busy()) show(step - 1, true, true); }));
    function schedule() {
      clearTimeout(timer);
      const from = step;
      timer = setTimeout(() => { if (visible() && step === from && !busy()) advance(); }, 250);
    }
    function updateWebsite() {
      const yes = selected('has_site')[0] === 'Da';
      form.querySelector('[data-guided-website]').hidden = !yes;
      form.querySelector('[data-guided-site-next]').hidden = !yes;
      form.elements.site_url.required = yes;
    }
    form.addEventListener('change', event => {
      clearError();
      const name = event.target.name;
      if (name === 'has_site') {
        clearTimeout(timer);
        updateWebsite();
        if (event.target.value === 'Nu') schedule();
      } else if (name === 'budget') schedule();
      if (['services','goals','has_site','budget'].includes(name)) form.querySelectorAll(`[name="${name}"]`).forEach(input => input.removeAttribute('aria-invalid'));
    });
    form.addEventListener('click', event => {
      const input = event.target;
      if (input.tagName === 'INPUT' && input.checked && (input.name === 'budget' || (input.name === 'has_site' && input.value === 'Nu'))) schedule();
    });
    form.addEventListener('input', clearError);
    dialog?.addEventListener('close', () => clearTimeout(timer));
    const defaultService = defaults[location.pathname.replace(/\/$/,'').split('/').pop()];
    if (defaultService) for (const input of form.querySelectorAll('[name=services]')) input.checked = input.value === defaultService;
    form.bossnetGuided = {
      open() { if (!form.hidden) {show(step, false);title.focus({preventScroll:true});} },
      beforeSubmit() {
        if (step < 5) {advance();return false;}
        for (let n=1;n<=5;n++) {
          // Validation must reveal the failing step before focusing its fields.
          show(n, false);
          if (!validate(n)) {if(dialog)dialog.scrollTop=0;return false;}
        }
        return true;
      },
      showServerErrors(errors) {
        const map = {services:1,goals:2,has_site:3,site_url:3,budget:4,name:5,phone:5,email:5,company:5};
        const target = Math.min(...Object.keys(errors).map(key => map[key] || 5));
        // The request is still busy; display the failed step without enabling a second submit.
        const wasBusy = form.getAttribute('aria-busy');form.removeAttribute('aria-busy');show(target);if(wasBusy)form.setAttribute('aria-busy',wasBusy);
      },
      failed() { recovery.hidden = false; },
      success() {
        clearTimeout(timer);
        if (dialog) {dialog.setAttribute('aria-labelledby',form.nextElementSibling.querySelector('h3').id);dialog.scrollTop=0;}
      }
    };
    updateWebsite();show(1,false);
  }
})();
